// extracted by mini-css-extract-plugin
module.exports = {"Lore":"Faerun_Lore__3xADj"};